import { useAuth } from '@/lib/auth'
import { getCurrentISOString } from '@/lib/dates'
import { captureException } from '@/lib/errors'
import { log } from '@/lib/logger'
import { useMutation } from '@/lib/mutations'
import { offlineExecutor } from '@/lib/offline'
import { newRecordId, useStore } from '@/lib/pocketbase'

interface StartBreakData {
    parentEntry: {
        job: string
        org: string
        location?: string
    }
}

export function useStartBreak() {
    const { user } = useAuth()
    const [timeEntriesCollection] = useStore('time_entries')

    const mutation = useMutation({
        networkMode: 'always',
        mutationFn: async (data: StartBreakData) => {
            if (!user?.id) {
                throw new Error('User not found')
            }

            const clockInTime = getCurrentISOString()
            const entryId = newRecordId()

            const tx = offlineExecutor.createOfflineTransaction({
                mutationFnName: 'syncTimeEntries',
            })
            tx.mutate(() => {
                timeEntriesCollection.insert({
                    id: entryId,
                    user: user.id,
                    org: data.parentEntry.org,
                    job: data.parentEntry.job,
                    location: data.parentEntry.location || '',
                    clock_in: clockInTime,
                    clock_out: '',
                    status: 'active',
                    entry_type: 'break',
                    notes: '',
                    duration: 0,
                    approved_by: '',
                    approved_at: '',
                    modified_by: '',
                    rejection_reason: '',
                    clock_in_location: null,
                    clock_out_location: null,
                })
            })

            log.info('Break started', { entryId })
        },
        onError: error => {
            captureException('Start break failed', error)
        },
    })

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
    }
}
